import React from "react";
import { Input } from "../../../components/ui/input";
import { Search, X } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";

const OrderFilters = ({ filters, setFilters }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const handleSearchChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setFilters((prev) => ({ ...prev, status: value === "all" ? "" : value }));
  };

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const clearFilters = () => {
    setFilters({ search: "", status: "", startDate: "", endDate: "" });
  };

  const hasActiveFilters =
    filters.search || filters.status || filters.startDate || filters.endDate;

  return (
    <div
      className={`rounded-xl p-3 space-y-3 ${isDark ? "bg-white/[0.03] border border-white/[0.06]" : "bg-white border border-gray-200/80"}`}
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search
            className={`absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 ${isDark ? "text-gray-600" : "text-gray-400"}`}
          />
          <Input
            placeholder="Zoek op naam, email of order ID..."
            value={filters.search}
            onChange={handleSearchChange}
            className={`pl-8 h-9 text-[13px] rounded-lg ${isDark ? "bg-white/[0.04] border-white/[0.06] text-white placeholder-gray-600" : "bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-400"}`}
          />
        </div>
        <select
          value={filters.status || "all"}
          onChange={handleStatusChange}
          className={`h-9 rounded-lg px-3 text-[13px] border ${isDark ? "bg-white/[0.04] border-white/[0.06] text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
        >
          <option value="all">Alle statussen</option>
          <option value="new">Nieuwe bestelling</option>
          <option value="handled">Afgehandeld</option>
          <option value="paid">Betaald</option>
          <option value="pending">In afwachting</option>
          <option value="shipped">Verzonden</option>
          <option value="cancelled">Geannuleerd</option>
        </select>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 items-end">
        <div className="grid grid-cols-2 gap-3 flex-1 w-full">
          <div className="space-y-1">
            <label
              className={`text-[11px] font-medium ${isDark ? "text-gray-500" : "text-gray-400"}`}
            >
              Van datum
            </label>
            <Input
              type="date"
              value={filters.startDate}
              onChange={(e) => handleDateChange("startDate", e.target.value)}
              className={`h-9 text-[13px] rounded-lg ${isDark ? "bg-white/[0.04] border-white/[0.06] text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
            />
          </div>
          <div className="space-y-1">
            <label
              className={`text-[11px] font-medium ${isDark ? "text-gray-500" : "text-gray-400"}`}
            >
              Tot datum
            </label>
            <Input
              type="date"
              value={filters.endDate}
              onChange={(e) => handleDateChange("endDate", e.target.value)}
              className={`h-9 text-[13px] rounded-lg ${isDark ? "bg-white/[0.04] border-white/[0.06] text-white" : "bg-gray-50 border-gray-200 text-gray-900"}`}
            />
          </div>
        </div>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className={`h-9 px-3 rounded-lg text-[12px] font-medium flex items-center gap-1.5 transition-colors ${isDark ? "text-gray-500 hover:text-white hover:bg-white/[0.04]" : "text-gray-400 hover:text-gray-700 hover:bg-gray-50"}`}
          >
            <X className="h-3 w-3" /> Wissen
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderFilters;
